import * as React from "react"

export default function Head({ title, description, image }) {
  return (
    <>
      <html lang="pt" />
      <meta charSet="utf-8" />
      <title>{title}</title>
      {description && (
        <meta
          name="description"
          property="og:description"
          content={description}
        />
      )}
      <meta property="og:type" content={'website'} />
      <meta property="og:url" content={'https://gogood.com.br'} />
      <meta property="og:title" content={title} />
      {image && <meta property="og:image" content={image.url} />}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:site" content="https://gogood.com.br" />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image.url} />}
    </>
  )
} 
